<app-megamenu></app-megamenu>

<div class="service-page">
  <!-- Hero Section -->
  <div class="hero-section">
    <div class="hero-background"></div>
    <div class="container">
      <div class="hero-content">
        <h1>Spider Control Services</h1>
        <p class="hero-subtitle">Professional spider elimination and web removal services. Keep your home spider-free with our comprehensive treatment programs.</p>
        <div class="hero-actions">
          <button mat-raised-button class="cta-button" (click)="navigateToContact()">
            <mat-icon>pest_control</mat-icon>
            Get Spider Control
          </button>
          <button mat-button class="phone-button" (click)="callPhone()">
            <mat-icon>phone</mat-icon>
            Call {{ config.phone.display }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Spider Types Section -->
  <div class="spider-types-section">
    <div class="container">
      <h2>Common Spiders We Control</h2>
      <p class="section-subtitle">From harmless house spiders to dangerous venomous species - we handle them all safely</p>
      
      <div class="spider-types-grid">
        <div *ngFor="let spider of spiderTypes" class="spider-card">
          <div class="spider-header">
            <h3>{{ spider.name }}</h3>
            <span class="danger-badge" [style.background-color]="getDangerColor(spider.danger)">
              {{ spider.danger }} Risk
            </span>
          </div>
          <p>{{ spider.description }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Treatment Areas Section -->
  <div class="treatment-section">
    <div class="container">
      <h2>Our Spider Control Methods</h2>
      <p class="section-subtitle">Comprehensive spider control targeting both existing spiders and prevention of new infestations</p>
      
      <div class="treatment-grid">
        <div *ngFor="let treatment of treatmentAreas" class="treatment-card">
          <mat-icon>cleaning_services</mat-icon>
          <h3>{{ treatment.area }}</h3>
          <p>{{ treatment.description }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Process Section -->
  <div class="process-section">
    <div class="container">
      <h2>Our Spider Control Process</h2>
      
      <div class="process-steps">
        <div class="step">
          <div class="step-number">1</div>
          <div class="step-content">
            <h3>Inspection</h3>
            <p>Identify spider species and locate webs, hiding spots, and entry points</p>
          </div>
        </div>
        
        <div class="step">
          <div class="step-number">2</div>
          <div class="step-content">
            <h3>Web Removal</h3>
            <p>Complete removal of all webs, egg sacs, and spider debris</p>
          </div>
        </div>
        
        <div class="step">
          <div class="step-number">3</div>
          <div class="step-content">
            <h3>Treatment</h3>
            <p>Apply targeted treatments to eliminate existing spiders</p>
          </div>
        </div>
        
        <div class="step">
          <div class="step-number">4</div>
          <div class="step-content">
            <h3>Prevention</h3>
            <p>Create protective barrier and seal entry points</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Safety Section -->
  <div class="safety-section">
    <div class="container">
      <div class="safety-content">
        <mat-icon>warning</mat-icon>
        <div class="safety-text">
          <h2>Black Widow Emergency?</h2>
          <p>If you've been bitten by a black widow or spider, seek medical attention immediately! If you see a black widow, We provide same-day service for black widow removal.</p>
        </div>
        <button mat-raised-button class="emergency-btn" (click)="callPhone()">
          <mat-icon>phone</mat-icon>
          Black Widow Removal
        </button>
      </div>
    </div>
  </div>

  <!-- Benefits Section -->
  <div class="benefits-section">
    <div class="container">
      <h2>Why Choose Our Spider Control?</h2>
      
      <div class="benefits-grid">
        <div class="benefit-card">
          <mat-icon>security</mat-icon>
          <h3>Safe Removal</h3>
          <p>Professional handling of dangerous spiders with proper safety equipment</p>
        </div>
        
        <div class="benefit-card">
          <mat-icon>cleaning_services</mat-icon>
          <h3>Complete Web Removal</h3>
          <p>Thorough removal of webs, egg sacs, and spider debris</p>
        </div>
        
        <div class="benefit-card">
          <mat-icon>shield</mat-icon>
          <h3>Long-term Protection</h3>
          <p>Preventive treatments to keep spiders from returning</p>
        </div>
        
        <div class="benefit-card">
          <mat-icon>verified</mat-icon>
          <h3>Guaranteed Results</h3>
          <p>We guarantee our spider control treatments with follow-up service</p>
        </div>
      </div>
    </div>
  </div>

  <!-- CTA Section -->
  <div class="cta-section">
    <div class="container">
      <h2>Get Rid of Spiders Today</h2>
      <p>Don't live with unwanted spiders. Our professional spider control eliminates current infestations and prevents new ones.</p>
      <div class="cta-buttons">
        <button mat-raised-button class="primary-cta" (click)="navigateToContact()">
          <mat-icon>pest_control</mat-icon>
          Schedule Spider Treatment
        </button>
        <button mat-button class="secondary-cta" (click)="callPhone()">
          <mat-icon>phone</mat-icon>
          Call for Free Quote
        </button>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>